
export interface TaskNetworkComponent {
    /**
     * Entity id
     */
    Id: string;

    /**
     * Id of the Task entity belongs to
     */
    TaskId: string;

    /**
     * Id of the feature for component in location data store
     */
    ComponentFeatureId: number | null;

    /**
     * Component type 
     */
    ComponentType: string;

    /**
     * Name/label of component
     */
    Name: string;

    /**
     * Information about the component, changes done to it or reported observations for it.
     */
    Notes: string;
}

export interface TaskNetworkComponentConfig extends Pick<TaskNetworkComponent,
    'TaskId' |
    'ComponentFeatureId' |
    'ComponentType' |
    'Name' |
    'Notes'> { }

export interface TaskNetworkComponentPatchConfig extends Partial<Pick<TaskNetworkComponent,
    'ComponentFeatureId' |
    'ComponentType' |
    'Name' |
    'Notes'>> { }

export interface TaskNetworkComponentChangeBase {
    /**
     * Change operation
     */
    operation: 'add' | 'edit' | 'delete' | 'batchAdd' | 'batchDelete';
}

export interface TaskNetworkComponentChange extends TaskNetworkComponentChangeBase {
    /**
     * Changed component entity id
     */
    id: string;

    /**
     * Possible component (available only in `add` and `edit` changes)
     */
    component?: TaskNetworkComponent;
}

export interface TaskNetworkComponentBatchChange extends TaskNetworkComponentChangeBase {
    /**
     * List of changed entities
     */
    batch: TaskNetworkComponentChange[];
}

export interface FeatureWithMetadata {
    type: string;
    geometry: {
        [key: string]: any;
    }
    properties: {
        Id: number | null;
        LayerId: string;
        ComponentType: string;
        Label: string;
        [key: string]: any;
    }
}

export interface ComponentHistoryDialogData {
    mobile: boolean;
    currentTaskId: string;
    component: TaskNetworkComponent;
}

export interface ComponentRelatedTask {
    Id: string;
    ComponentFeatureId: number | null;
    ComponentType: string;
    Name: string;
    Notes: string;
    TaskId: string;
    TaskIdentifier: string;
    TaskName: string;
    TaskIwmId: number;
    TaskType: string;
}

export enum FeatureComponentTypeMap {
    disconnector = 'Disconnector',
    disconnector_station = 'DisconnectorStation',
    distribution_cabinet = 'DistributionCabinet',
    distribution_transformer = 'DistributionTransformer',
    network = 'Network',
    pole = 'Pole',
    route = 'Route',
    switch = 'Switch',
    transformer = 'Transformer',
    subscription = 'Subscription',
    satnet_risk = 'SatNet Risk'
}

// Needed for blah translations
export enum ComponentFeatureTypeMap {
    Disconnector = 'disconnector',
    DisconnectorStation = 'disconnector_station',
    DistributionCabinet = 'distribution_cabinet',
    DistributionTransformer = 'distribution_transformer',
    Network = 'network',
    Pole = 'pole',
    Route = 'route',
    Switch = 'switch',
    Transformer = 'transformer',
    Subscription = 'subscription',
    satnet_risk = 'satnet_risk'
}
